async function estimatedDeliveryDate() {
    let finalDeliveryDates, deliveryMinDate, deliveryMaxDate;
    let estDateTime = moment().tz('America/New_York');
    const mainProductForm = Array.from(document.querySelectorAll('.buy_buttons__wrapper .product-form')).find(form => form.style.display !== 'none')?.closest('.product-form-wrapper');
    const orderCutOffTime = parseInt(13);
    const minimumDeliveryDays = parseInt(3);
    const maximumDeliveryDays = parseInt(6);
    const estimatedDeliveryMsgs = document.querySelectorAll('.estimated-delivery-date-wrapper');
    const cartEstimatedDeliveryMsg = document.querySelector('.cart-drawer .estimated-delivery-date-wrapper');
    const productEstimatedDeliveryMsg = Array.from(estimatedDeliveryMsgs).find(msg => msg.closest('.product'));
    const isVariantSoldOut = mainProductForm?.getAttribute('data-product-soldout') === 'soldout';
    const isPreOrderProduct = mainProductForm?.getAttribute('data-has-preorder-msg') === 'true';
    const userCountryCode = await window.getCountryCode();
    const enableDeliveryMsg = userCountryCode === 'US' || userCountryCode === 'CA';

    if(!enableDeliveryMsg) {
        estimatedDeliveryMsgs.forEach(msg => msg.classList.add('hidden'));
        return
    };

    // check and skip order cut off time
    if(orderCutOffTime > 0 && parseInt(estDateTime.format('HH')) > orderCutOffTime) getNextBusinessDay();

    function getNextBusinessDay() {
        estDateTime.add(1, 'days');

        while(estDateTime.isHoliday() || estDateTime.day() === 6 || estDateTime.day() === 0) {
            estDateTime.add(1, 'days');
        }
    }

    // calculate min/max delivery dates excluding weekends and holidays
    function calcDeliveryDate(date, totalDays) {
        for(let i=0;i<totalDays;i++) {
            date.add(1, 'days');
            if(date.isHoliday() || date.day() === 6 || date.day() === 0) {
                i--;
            }
        }
        return date;
    }

    // check and skip holidays/weekends
    deliveryMinDate = calcDeliveryDate(estDateTime.clone(), minimumDeliveryDays);
    deliveryMaxDate = calcDeliveryDate(estDateTime.clone(), maximumDeliveryDays);

    finalDeliveryDates = `${deliveryMinDate.format('ddd, MMM DD')} - ${deliveryMaxDate.format('ddd, MMM DD')}`;

    if(estimatedDeliveryMsgs.length && finalDeliveryDates) {
        if(productEstimatedDeliveryMsg && !isVariantSoldOut && !isPreOrderProduct) productEstimatedDeliveryMsg.classList.remove('hidden');
        if(cartEstimatedDeliveryMsg) cartEstimatedDeliveryMsg.classList.remove('hidden');
        estimatedDeliveryMsgs.forEach(div => {
            div.querySelector('.estimate-delivery-date').textContent = finalDeliveryDates;
        })
    }
}

function callDeliveryFunction() {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        estimatedDeliveryDate();
    })
}

async function momentHolidays() {
    const userCountryCode = await window.getCountryCode();
    const script = document.createElement('script');
    if(userCountryCode === 'US') {
      script.src = "//www.cariuma.com/cdn/shop/t/1940/assets/moment-holiday-us.min.js?v=143830068500599088301750433771";
    } else if(userCountryCode === 'CA') {
      script.src = "//www.cariuma.com/cdn/shop/t/1940/assets/moment-holiday-ca.min.js?v=60220643407808819971750433771";
    }
    script.defer = true;
    document.head.appendChild(script);

    script.onload = () => {
        if(moment && moment.holidays?.active) {
            estimatedDeliveryDate();
            callDeliveryFunction();
        }
    }
}
momentHolidays();